.stickyContainer {
  position: sticky;
  top: 0;
  background: var(--paletteWhite0);
  z-index: 20;
  padding-bottom: var(--spacingMd);
}
